'use strict';

class PartialPagination {
    /**
     * PartialPage のページング情報を取り扱うクラスです
     *
     * @param prevCursor {string|null}
     * @param prevMore {boolean}
     * @param nextCursor {string|null}
     * @param nextMore {boolean}
     */
    constructor(prevCursor, prevMore, nextCursor, nextMore) {
        this._prevCursor = prevCursor;
        this._prevMore = prevMore;
        this._nextCursor = nextCursor;
        this._nextMore = nextMore;
    }

    get prevCursor() {
        return this._prevCursor;
    }

    get prevMore() {
        return this._prevMore;
    }

    get nextCursor() {
        return this._nextCursor;
    }

    get nextMore() {
        return this._nextMore;
    }

    get hasMore() {
        return this.prevMore || this.nextMore;
    }

    clearPrevSide() {
        const prevCursor = null;
        const prevMore = false;
        return new PartialPagination(
            prevCursor,
            prevMore,
            this._nextCursor,
            this._nextMore
        );
    }

    clearNextSide() {
        const nextCursor = null;
        const nextMore = false;
        return new PartialPagination(
            this._prevCursor,
            this._prevMore,
            nextCursor,
            nextMore
        );
    }

    isEmpty() {
        return (
            this.prevCursor == null &&
            this.prevMore === false &&
            this.nextCursor == null &&
            this.nextMore === false
        );
    }

    /**
     * 空のページング情報 (順方向、逆方向ともにページなし) を持った PartialPagination オブジェクトを返します
     *
     * @return {PartialPagination}
     */
    static buildEmpty() {
        return new PartialPagination(null, false, null, false);
    }
}

module.exports = PartialPagination;



// WEBPACK FOOTER //
// ./framework/domain/partial-page/partial-pagination.js